import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Input,
  Checkbox,
  Radio
} from "antd";
import "../style.css";
import {
  SortableElement,
  SortableHandle
} from "react-sortable-hoc";

const Sortable = SortableElement(item => {
  return <div>{item.children}</div>;
});

const DragHandle = SortableHandle(() => (
  <div className="askEdit-item-multiple-option-sort">
    <FontAwesomeIcon
      icon={["fal", "grip-lines"]}
      style={{ color: "#0090d1" }}
    />
  </div>
));

const SortableEl = props => {
  const {
    itm,
    cn,
    item,
    index,
    placeholderInput,
    conditionToRemove,
    onInputChange
  } = props;

  return (
    <Sortable index={index ? index : null}>
      <div className="askEdit-item-multiple-option">
        <div style={{ display: "flex" }}>
          <DragHandle />
          <div className="askEdit-item-multiple-option-check">
            {item.type === "checkbox" ? (
              <Checkbox disabled />
            ) : (
              <Radio disabled />
            )}
          </div>
          <Input
            name={"askEdit-item-multiple-option_" + cn}
            className="askEdit-item-multiple-option-input"
            placeholder={placeholderInput}
            onChange={e =>
              onInputChange(
                "editOption",
                item.id,
                e.target.value,
                parseInt(e.target.name.split("_")[1])
              )
            }
            value={itm}
          />
        </div>
        <div className="askEdit-item-multiple-option-icons">
          {
            <div
              className="askEdit-item-multiple-option-add"
              onClick={() => onInputChange("addOption", item.id)}
            >
              <FontAwesomeIcon icon={["fal", "plus-circle"]} />
            </div>
          }
          {conditionToRemove && (
            <div
              name={"askEdit-item-multiple-option-remove_" + cn}
              className="askEdit-item-multiple-option-remove"
              onClick={e => {
                if (e.target.getAttribute("name")) {
                  onInputChange(
                    "removeOption",
                    item.id,
                    "",
                    e.target.getAttribute("name").split("_")[1]
                  );
                } else if (e.target.parentElement.getAttribute("name")) {
                  onInputChange(
                    "removeOption",
                    item.id,
                    "",
                    e.target.parentElement.getAttribute("name").split("_")[1]
                  );
                }
              }}
            >
              <FontAwesomeIcon
                name={"askEdit-item-multiple-option-remove_" + cn}
                icon={["fal", "trash-alt"]}
              />
            </div>
          )}
        </div>
      </div>
    </Sortable>
  );
};
export default SortableEl;
